import { BoxDanger, MnemoLoading, MSection, SupportoTecnico, Title } from "components/misc";
import { ROUTES, TITLEREQUEST_STEPS } from "const";
import { Icon } from "design-react-kit";
import { networkErrorHelper } from "libs";
import { certificationRequestService } from "libs/api";
import React, { Component } from "react";
import { NavLink, withRouter } from 'react-router-dom';

import { MnemoStepper } from "components/misc/MnemoStepper";

import {
    CertificationRequestStart,
    CertificationRequestSign,
    CertificationRequestPay,
    CertificationRequestDownload
} from "components/certificationRequest/";

const STEP_START = {
    stepName: TITLEREQUEST_STEPS.START,
    handler: new CertificationRequestStart(),
    progress: 0
};

const STEP_SIGN = {
    stepName: TITLEREQUEST_STEPS.SIGN,
    handler: new CertificationRequestSign(),
    progress: 1,
    nextButton: 'Firma la richiesta'
};

const STEP_PAY = {
    stepName: TITLEREQUEST_STEPS.PAY,
    handler: new CertificationRequestPay(true),
    progress: 2,
};

const STEP_DOWNLOAD = {
    stepName: TITLEREQUEST_STEPS.DOWNLOAD,
    handler: new CertificationRequestDownload(),
    progress: 3
}

class UCSUCertificationRequest extends Component {

    state = {
        certificationRequest: null,
        certificationRequestMNEMO: null,
        certificationRequestGOMP: null,
        user: null,
        userProfile: null,
        loading: true,
        ladingError: false,
        requestError: '',
        rCode: '',
        prevDisabled: true,
        currentProgress: 0,
        steps: []
    };

    componentDidMount() {

        const { rCode } = this.props.match.params;
        this.loadRemote(rCode);

    }

    loadRemote(rCode) {

        certificationRequestService
            .getPendingRequest(rCode)
            .then(({ data }) => {

                const { certificationRequest, user, userProfile } = data.payload;
                if (certificationRequest) {
                    this.setState({ certificationRequest });
                    this.loadRequestMNEMO(data.payload, rCode);
                } else {
                    const { steps, currentProgress } = this.createSteps(data.payload);
                    this.setState({ steps, currentProgress, rCode, user, userProfile });
                }
            })
            .catch(error => {

                networkErrorHelper.notify(error);

                console.log(error);
                this.setState({ loadingError: true, loading: false, rCode });
            });
    }

    loadRequestMNEMO(payload, rCode) {

        // verify if the request exists
        certificationRequestService
            .getRequestMNEMO(rCode)
            .then(({ data }) => {

                const { certificationRequestMNEMO, certificationRequestGOMP, paymentMNEMO, paymentGOMP } = data.payload;
                const { steps, currentProgress } = this.createSteps({ ...payload, ...data.payload });

                // verify if there was an error during the request                
                const requestError = (certificationRequestGOMP && certificationRequestGOMP.error) ? certificationRequestGOMP.error : '';
                const loadingError = (requestError.length > 0) ? true : false;

                this.setState({
                    steps, currentProgress, rCode,
                    certificationRequestMNEMO: certificationRequestMNEMO,
                    paymentMNEMO, paymentGOMP,
                    certificationRequestGOMP,
                    loading: false,
                    loadingError: loadingError,
                    requestError
                });

            })
            .catch(error => {

                if (!networkErrorHelper.is404(error)) {
                    networkErrorHelper.notify(error);
                }
                console.log(error);
                this.setState({ loadingError: true });
            });
    }

    createSteps(payload) {

        const steps = [];
        STEP_START.handler.setPayload(payload);
        steps.push(STEP_START);
        STEP_SIGN.handler.setPayload(payload);
        steps.push(STEP_SIGN);
        STEP_PAY.handler.setPayload(payload);
        steps.push(STEP_PAY);
        STEP_DOWNLOAD.handler.setPayload(payload);
        steps.push(STEP_DOWNLOAD);

        // get currentProgress
        let currentProgress = 0;
        if (payload && payload.certificationRequest) {
            const items = steps.filter(item => item.stepName === payload.certificationRequest.currentStep);
            if ((items && items.length > 0)) {

                currentProgress = items[0].progress;
            }
        }

        return { steps, currentProgress };
    }

    render() {

        const { loading, loadingError, requestError, rCode } = this.state;

        if (loading) return (<MnemoLoading></MnemoLoading>);

        return (<>
            <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right">
                <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
            <Title>Richiesta Certificazione</Title>
            <MSection>
                {(loadingError)
                    ? <>
                        <BoxDanger className="mt-4">
                            Si è verificato un errore durante il caricamento della pagina, se il problema persiste puoi <SupportoTecnico />
                            {(requestError.length > 0) && (<p>Codice Errore: {requestError}</p>)}
                        </BoxDanger>
                    </>
                    : <>
                        <MnemoStepper {...this.state} />
                    </>
                }

            </MSection>
        </>);
    }
}

export default withRouter(UCSUCertificationRequest);